var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('list-header',{on:{"search":_vm.search}}),_vm._v(" "),_c('table-list',{ref:"TableList",attrs:{"fetchAction":_vm.fetchAction,"filter":_vm.filter,"cols":_vm.cols,"dataActions":_vm.dataActions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }